export default defineNuxtPlugin({
  name: 'tracking',
  setup() {
    // Skip tracking on local dev so developer traffic never reaches the prod GA4 property
    const isDev = import.meta.dev;
    const isLocalhost = typeof globalThis.window !== 'undefined' && /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/.test(globalThis.window.location.origin);
    if (isDev || isLocalhost) {
      return;
    }

    // Google Consent Mode v2 - set defaults BEFORE GTM loads.
    // Must be pushed gtag-style (the `arguments` object): GTM ignores a plain array
    // ['consent', 'default', ...], which left consent unconfigured.
    // analytics_storage granted so the _ga cookie is set on the landing page and shared
    // with invest.equirize.com; ads denied since Google Ads is not in use.
    if (typeof globalThis.window !== 'undefined') {
      const win = globalThis.window as Window & { dataLayer?: unknown[] };
      win.dataLayer = win.dataLayer || [];
      // eslint-disable-next-line prefer-rest-params
      const gtag = function (..._args: unknown[]) { win.dataLayer!.push(arguments); };
      gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'granted',
      });
    }

    // Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MCL87SSD');`;
    document.head.appendChild(gtmScript);

    // GTM Noscript (add to body)
    const gtmNoscript = document.createElement('noscript');
    gtmNoscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MCL87SSD" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
    if (document.body) {
      document.body.insertBefore(gtmNoscript, document.body.firstChild);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        document.body.insertBefore(gtmNoscript, document.body.firstChild);
      });
    }

    // Microsoft Clarity - with error handling to prevent console errors
    // Load Clarity asynchronously to avoid blocking and handle failures gracefully
    if (typeof globalThis.window !== 'undefined') {
      const loadClarity = () => {
        try {
          const clarityScript = document.createElement('script');
          clarityScript.type = 'text/javascript';
          clarityScript.async = true;
          
          // Wrap Clarity initialization with comprehensive error handling
          clarityScript.innerHTML = `(function(c,l,a,r,i,t,y){
            try {
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              // Suppress errors on the script tag itself
              t.onerror=function(){return false;};
              y=l.getElementsByTagName(r)[0];
              if(y&&y.parentNode){
                y.parentNode.insertBefore(t,y);
              } else {
                (l.head||l.getElementsByTagName('head')[0]||l.documentElement).appendChild(t);
              }
            } catch(e) {
              // Silently handle any initialization errors
              return false;
            }
          })(globalThis, document, "clarity", "script", "upg6bjin3a");`;
          
          // Add error handler to prevent uncaught errors
          clarityScript.onerror = function() {
            return false; // Prevent error propagation
          };
          
          document.head.appendChild(clarityScript);
        } catch (error) {
          // Network errors from blocked scripts are expected; intentionally no-op
          void error;
        }
      };
      
      // Load Clarity after page is idle to avoid blocking initial render
      if ('requestIdleCallback' in globalThis.window) {
        globalThis.window.requestIdleCallback(loadClarity, { timeout: 2000 });
      } else {
        // Fallback for browsers without requestIdleCallback
        setTimeout(loadClarity, 100);
      }
    }
  },
});
